import React from "react";
import { Globe } from "lucide-react";
import PromptStore from "../../store/promptStore";
import { useSparkContext } from "../../context/SparkContext";
import CustomTooltip from "../Tooltip/CustomTooltip";

const WebSearchToggle = ({
  enabled,
  onToggle,
  compact = false,
  disabled = false,
}) => {
  const { space } = useSparkContext();
  const storeWebSearchEnabled = PromptStore((state) => state.webSearchEnabled ?? true);
  const setWebSearchEnabled = PromptStore((state) => state.setWebSearchEnabled);

  const disabledBySpace = space?.web_search_enabled === false;
  const isEnabled = disabledBySpace
    ? false
    : (enabled !== undefined ? Boolean(enabled) : storeWebSearchEnabled);
  const isControlDisabled = disabled || disabledBySpace;

  const handleClick = () => {
    if (isControlDisabled) return;
    if (onToggle) {
      onToggle(!isEnabled);
    } else if (setWebSearchEnabled) {
      setWebSearchEnabled(!isEnabled);
    }
  };

  const tooltipText = disabledBySpace
    ? "Web search is disabled for this Spectra"
    : isEnabled
      ? "Web search enabled — click to disable"
      : "Web search disabled — click to enable";

  return (
    <CustomTooltip content={tooltipText} side="top" align="center">
      <button
        type="button"
        onClick={handleClick}
        disabled={isControlDisabled}
        aria-pressed={isEnabled}
        aria-label={
          disabledBySpace
            ? "Web search disabled for this Spectra"
            : isEnabled
              ? "Web search enabled"
              : "Web search disabled"
        }
        className={`group ${
          compact ? "w-7 h-7" : "w-[36px] h-[36px]"
        } flex items-center justify-center rounded-full hover:shadow-[0_0_0_0.5px_#6D808D4D] hover:bg-fill-navigation-hover hover:dark:bg-fill-navigation-hover-dark transition-colors relative ${
          isControlDisabled ? "cursor-not-allowed opacity-60" : "cursor-pointer"
        }`}
      >
        <Globe
          size={compact ? 15 : 17}
          className={
            isEnabled
              ? "text-ink-primary dark:text-ink-accent"
              : "text-ink-control-border dark:text-ink-gray-400"
          }
        />
      </button>
    </CustomTooltip>
  );
};

export default WebSearchToggle;
